<template>
  <div>
    <common-dialog
      ref="dialog"
      width="900px"
      :show-save-button="false"
      unit="安全员"
      edit-title
      title="安全员详情"
      form-label-width="140px"
      id-key="DpId"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :before-save="onBeforeSave"
      close-on-saved
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基础信息
        <el-row class="row-border">
          <el-row>
            <el-col :span="12">
              <el-col :span="24">
                <el-form-item label="归属机构" prop="DpId">
                  {{data.DpName}}
                  <!-- <tree-select
                    ref="treeSelect"
                     
                    :props="props"
                    :options="TreeData"
                    :value="data.DpId"
                    :clearable="true"
                    :accordion="true"
                    :parentSelect="true"
                    placeholder="请选择"
                    @node-select="onTreeSelect($event)"
                  /> -->
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名" prop="FullName">
                  {{data.FullName}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="性别" prop="Sex">
                  {{data.Sex==1?'男':'女'}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="身份证号" prop="IdCard">
                  {{data.IdCard}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="出生日期" prop="BirthDate">
                  {{$commonJs.toDateString(data.BirthDate)}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="手机号码" prop="Mobile">
                  {{data.Mobile}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="联系地址" prop="Address">
                  {{data.Address}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="准驾车型" prop="DriveCarType">
                  {{data.DriveCarType}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="准教车型" prop="TeachCarType">
                  {{data.TeachCarType}}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="驾驶证号" prop="DriveNo">
                  {{data.DriveNo}}
                </el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-col :span="24">
                <div class="uploadBox">
                  证件照
                  <img v-if="data.CertUrl" :src="host + '/api' + data.CertUrl" class="avatar" style="margin-top:8px;">
                </div>
                <div class="uploadText">
                  <p>照片要求</p>
                  <p>1、证件照可上传或者连接摄像头现场拍摄</p>
                  <p>2、上传或拍摄照片要求为白底免冠</p>
                  <p>3、上传的照片大小不超过高377px*宽307px</p>
                  <p>4、图片大小500k之内</p>
                </div>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="驾驶证初领日期" prop="DriveDate">
                {{$commonJs.toDateString(data.DriveDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="入职日期" prop="InDate">
                {{$commonJs.toDateString(data.InDate)}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任职类型" prop="InType">
                {{data.InType==0?'自有':'加盟'}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="任职状态" prop="InStatus">
                {{data.InStatus==0?'在职':'离职'}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                {{data.Remark}}
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <span v-if="data.ReviewTime">审批信息</span>
        <el-row class="row-border" v-if="data.ReviewTime">
          <el-col :span="12">
            <el-form-item label="审批人">
              {{data.ReviewUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批时间">
              {{data.ReviewTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审批状态">
              <span v-if="data.Status==0">草稿</span>
              <span v-else-if="data.Status==1">待审批</span>
              <span v-else-if="data.Status==2">退回</span>
              <span v-else-if="data.Status==3">已审批</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="(data.Status==0||data.Status==2)&&data.ReviewTime">
            <el-form-item label="退回原因">
              {{data.ReviewRemark}}
            </el-form-item>
          </el-col>
        </el-row>
        备案信息
        <el-row class="row-border">
          <el-col :span="24">
            <el-form-item label="全国统一编码">
              {{data.CoachCode}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案人">
              {{data.RecordUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案时间">
              {{data.RecordTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案状态">
              <span v-if="data.RecordStatus==0" style="color:#f11;">未备案</span>
              <span v-else-if="data.RecordStatus==1">备案中</span>
              <span v-else-if="data.RecordStatus==2" style="color:#f11;">备案失败</span>
              <span v-else-if="data.RecordStatus==3">备案通过</span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.RecordRemark">
            <el-form-item label="备案备注">
              {{data.RecordRemark}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核状态">
              <span v-if="data.ExamStatus==0">待审核</span>
              <span v-else-if="data.ExamStatus==1">审核中</span>
              <span v-else-if="data.ExamStatus==2">审核失败</span>
              <span v-else-if="data.ExamStatus==3">审核成功</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核时间">
              {{data.ExamTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备案审核意见">
              {{data.ExamRemark}}
            </el-form-item>
          </el-col>
        </el-row>
        其他信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="创建人">
              {{data.AddUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              {{data.AddTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改人">
              {{data.UpdateUserName}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间">
              {{data.UpdateTime}}
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer>
        <template v-if="$permission.canReview()&&(data.RecordStatus==0||data.RecordStatus==2)">
          <el-button type="success" @click="pass" v-if="data.Status==1">通 过</el-button>
          <el-button type="danger" @click="back(1)" v-if="data.Status==1">退 回</el-button>
          <el-button type="danger" @click="back(2)" v-if="data.Status==3">撤销审批</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <return-dialog ref="returnDialog" @confirm="toReturn" ></return-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import treeSelect from "@/components/common/treeSelect";
import returnDialog from "@/components/schoolmanage/dp/returnDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    returnDialog,
    treeSelect
  },
  data() {
    return {
      data: {
        CoachId: 0,
        DpId: 0,
        DpName: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        BirthDate: "",
        Mobile: "",
        Address: "",
        DriveCarType: "",
        TeachCarType: "",
        DriveNo: "",
        DriveDate: "",
        InDate: "",
        InType: null,
        InStatus: null,
        Remark: "",
        CertUrl: "",
        Status: 0,
        CoachType: 1,
        CoachCode: "",
        // ---------
        ReviewUserName: "",
        ReviewTime: "",
        ReviewRemark: "",
        AddUserName: "",
        AddTime: "",
        UpdateUserName: "",
        UpdateTime: "",
        RecordStatus: 0,
        RecordTime: "",
        RecordUserName: "",
        RecordRemark: "",
        ExamStatus: 0,
        ExamTime: "",
        ExamRemark: ""
      },
      api: require("@/api/schoolmanage/coach").default,
      BusinessRanges: [],
      PicUrls: [],
      dpList: [],
      TreeData: [],
      disName: "",
      headers: { Authorization: "" },
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      backType: null,
      isMB: this.$store.state.isMB,
      rules: {
        DpId: [{ required: true, message: "请选择归属机构" }],
        FullName: [{ required: true, message: "请填写姓名" }],
        Sex: [{ required: true, message: "请选择性别" }],
        IdCard: [{ required: true, message: "请填写身份证号" }],
        // DriveCarType: [{ required: true, message: "请选择准驾车型" }],
        // TeachCarType: [{ required: true, message: "请选择准教车型" }],
        BirthDate: [{ required: true, message: "请选择出生日期" }],
        Mobile: [{ required: true, message: "请填写手机号码" }],
        DriveNo: [{ required: true, message: "请填写驾驶证号" }],
        DriveDate: [{ required: true, message: "请选择驾驶证初领日期" }],
        InDate: [{ required: true, message: "请选择入职日期" }],
        InType: [{ required: true, message: "请选择任职类型" }],
        InStatus: [{ required: true, message: "请选择任职状态" }],
      },
    };
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  methods: {
    onCreateOpened(data) {
      
    },
    onEditOpened(data) {
      
    },
    onDetailsOpened(data) {
      this.onEditOpened(data);
    },
    pass() {
      this.$confirm("确认通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.pass({ Id: this.data.CoachId, Remark: "" }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success("操作成功");
              this.close(true);
              this.$emit('close-saved');
            } else {
              this.$message.error(res.Msg);
            }
          })
        })
        .catch(() => {});
    },
    back(t) {
      this.backType = t;
      this.$refs.returnDialog.open(t);
    },
    toReturn(data) {
      this.loading(true);
      if(this.backType==1) {
        this.api.back({ Id: this.data.CoachId, Remark: data.Remark }).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.$message.success(res.Msg);
            this.close(true);
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      } else {
        this.api.cancelReview({ Id: this.data.CoachId, Remark: data.Remark }).then(res => {
          this.loading(false);
          if(res.Code==0) {
            this.$message.success(res.Msg);
            this.close(true);
            this.$emit('close-saved');
          } else {
            this.$message.error(res.Msg);
          }
        })
      }
    },
    onSuccess(res,file,fileList) {
      
    },
    beforePhotoUpload(file) {
      this.headers.Authorization = "Bearer " + localStorage.getItem("token");
    },
    picRemove(file) {
      
    },
    onSuccess2(res) {
      
    },
    picRemove2(file) {
      
    },
    toSave(type) {
      
    },
    onBeforeSave(data) {
      
    },
    onClosed() {
      
    },
  },
};
</script>
<style lang="scss">
.uploadBox{
    width: 232px;
    height: 285px;
    border: 1px solid #DCDFE6;
    margin: auto;
    padding: 8px 15px 0;
    i{
        font-size: 28px;
        color: #8c939d;
    }
}
.uploadText{
  margin-left: 82px;
  color: red;
  line-height: 14px;
}
.avatar {
  width: 200px;
  height: 230px;
}
</style>